import request from 'superagent';
import Model from '/app/src/model/model';
import CustomerModel from '../Customer/model';
import * as conversation from './actions';
import {List, fromJS } from 'immutable';
import ConversationSelector from '../Conversation/selector'

class Conversation extends Model {

    constructor() {
        super()
        this.timeout = {}
        this.randomEntryId = 1
        this.waitIamWriting = false
        this.selector = ConversationSelector
    }

    puts(tickets, type) {
        return (dispatch) => {
            Object.keys(tickets).forEach((room) => {
                dispatch(this.setInfo(room, tickets[room]));
                dispatch(this.setType(room, type));
            })
        }
    }

    setsRead(reads){
        return (dispatch) => {
            dispatch(conversation.setsRead(reads))
        }
    }

    setParticipantRead(room, participantId){
        return (dispatch) => {
            dispatch(conversation.setParticipantRead(room, participantId))
        }
    }

    setReadToDB(room, unread){
        return (dispatch) => {
            var url = this.url()
            var token = this.token()
            const state = this.state();

            let userId = state.getIn(['user', 'login', 'id'])
            let convo = ConversationSelector.getByRoom(state, room)
            let unread = ConversationSelector.getUnread(convo, userId)
            // no unneccesary send if unread is 0
            if(unread === 0) return;
            // if unassigned, this request would not work anyway
            if(ConversationSelector.typeOf(convo) === 'unassigned') return;
            request
             .put(`${url}/v1/room/unread`)
             .accept('application/json')
             .send({room: room})
             .set('Authorization', 'Bearer ' + token)
             .end((err, res) => {
                 dispatch(conversation.setParticipantRead(room, userId.toString()))
             })
             return null;
        }
    }

    readFromDB(room){
        return (dispatch) => {
            var url = this.url()
            var token = this.token()
            return request
                .post(`${url}/v1/ticket/get`)
                .accept('application/json')
                .send({room: room})
                .set('Authorization', 'Bearer ' + token)
                .end((err, res) => {
                    if (res.statusCode === 200){
                        const ticket = res.body.ticket
                        dispatch(this.setInfo(room, ticket));
                        dispatch(CustomerModel.readFromRawConversation(ticket))
                    }
                });
        }
    }

    deleteFromDB(room){
        const selectorFunction = (state) => {
            return { }
        }
        const dispatchFunction = (room)=> {
            return (dispatch) => {
                var url = this.url()
                var token = this.token()
                return request
                    .post(`${url}/v1/ticket/delete`)
                    .accept('application/json')
                    .send({room: room})
                    .set('Authorization', 'Bearer ' + token)
                    .end((err, res) => {
                        if (res.statusCode === 200){
                            dispatch(conversation.deleteConversation(room));
                        }
                    });
            }
        }
        return { selector: selectorFunction, dispatcher: dispatchFunction }
    }

    setInfo(room , info){
        return (dispatch) => {
            dispatch(conversation.setInfo(room, info));
        }
    }
    setsInfo(conversations){
        return (dispatch) => {
            dispatch(conversation.setsInfo(conversations));
        }
    }

    setType(room, type){
        return (dispatch) => {
            dispatch(conversation.setType(room, type));
        }
    }
    // many room
    setsType(rooms, type){
        return (dispatch) => {
            dispatch(conversation.setsType(rooms, type));
        }
    }

    setMetaInfo(room, info){
        return (dispatch) => {
            dispatch(conversation.setMetaInfo(room, info));
        }
    }


    getEntryRandomId() {
        this.randomEntryId += 1;
        var user_id = this.state().getIn(['user', 'login', 'id']);
        return `employee_${user_id}_entry_${this.randomEntryId}`;
    }

    addUnconfirmedEntry(room, entryBody){
        return (dispatch) => {
            var socket = this.socket();
            var token = this.token()
            var entryRandomId = this.getEntryRandomId()
            const entry = {
                'entry_body': entryBody,
                'entryRandomId': entryRandomId
            }

            dispatch(conversation.addUnconfirmedEntry(room, entry));
            socket.emit('post_entry', entryBody, room, token, 'employee', entryRandomId);
        }
    }

    putConfirmedEntries(room, entries){
        return (dispatch) => {
            dispatch(conversation.putConfirmedEntries(room, entries));
        }
    }

    addConfirmedEntry(room, entry){
        return (dispatch) => {
            dispatch(conversation.addConfirmedEntry(room, entry));
            dispatch(conversation.stopTyping(room));
        }
    }

    updateEntry(room, entry){
        return dispatch => {
            dispatch(conversation.updateEntry(room ,entry))
        }

    }

    addBulkEntries(entries){
        return (dispatch) => {
            dispatch(conversation.addBulkEntries(entries))
        }
    }

    setEntryToConfirmed(room, entryRandomId){
        return (dispatch) => {
            dispatch(conversation.setEntryToConfirmed(room, entryRandomId));
        }
    }

    isTyping(room) {
        return (dispatch) => {

            // If there is previous timeout for this room, remove it
            if (this.timeout[room]){
                clearTimeout(this.timeout[room]);
                this.timeout[room] = '';
            }

            // Setup timeout for typing event
            var timeoutId = setTimeout(() => {
                dispatch(conversation.stopTyping(room));
            }, 5000)
            this.timeout[room] = timeoutId;

            dispatch(conversation.isTyping(room));
        }
    }

    emitUserWritingClient(room){
        return (dispatch) => {
            if(!this.waitIamWriting){
                var socket = this.socket();
                var token = this.token()
                socket.emit('user_writing_client', room, token, 'employee');
                this.waitIamWriting = true;
                setTimeout(() => this.waitIamWriting=false, 2500)
            }
        }
    }

    removeEntries(room) {
        return (dispatch) => {
            dispatch(conversation.removeEntries(room));
        }
    }

    readEntries(room, offset=0) {
        return (dispatch) => {
            dispatch(conversation.readEntriesRequest(room))
            var url = this.url()
            var token = this.token()
            return request
                .get(`${url}/v1/room/entries`)
                .accept('application/json')
                .query(`room=${room}`)
                .query(`offset=${offset}`)
                .send({})
                .set('Authorization', 'Bearer ' + token)
                .end((err, res) => {
                    if (res.statusCode === 200){
                        dispatch(conversation.readEntriesSuccess(room, res.body.entries));
                    } else {
                        dispatch(conversation.readEntriesFailure(room, err, res));
                    }
                });
        }
    }

    createTag(room, text, tags, color='black') {
        return (dispatch) => {
            const url= this.url();
            const token = this.token();
            return request
                .post(`${url}/v1/ticket/tag/create`)
                .accept('application/json')
                .send({
                    ticket_room: room,
                    text: text,
                    color: color
                })
                .set('Authorization', 'Bearer ' + token)
                .end((err, res) => {
                    if (res.statusCode === 200) {
                        const oldTags = List(fromJS(tags));
                        const tag = List([fromJS(res.body.tag)]);
                        const newTags = oldTags.concat(tag);
                        dispatch(conversation.createTagSuccess(room, newTags));
                    }
                });
        }
    }

    deleteTag(room, tags, index) {
        return (dispatch) => {
            const tagId = tags.getIn([index, 'id']);
            const url = this.url();
            const token = this.token();
            return request
                .post(`${url}/v1/ticket/tag/delete`)
                .accept('application/json')
                .send({
                    ticket_room: room,
                    tag_id: tagId
                })
                .set('Authorization', 'Bearer ' + token)
                .end((err, res) => {
                    if (res.statusCode === 200) {
                        const updatedTags = tags.delete(index);
                        dispatch(conversation.deleteTagSuccess(room, updatedTags));
                    }
            })
        }
    }

    uploadFile(room, contentType, fileName, dataBlob, handleResponse){
        const url = this.url()
        const token = this.token()
        const routePath = '/v1/room/file/upload_url/get'
        return request
            .post(url + routePath)
            .send({room: room, content_type: contentType, file_name: fileName})
            .accept('application/json')
            .set('Content-Type', 'application/json')
            .set('Authorization', 'Bearer ' + token)
            .then((res) => {
                if(res.statusCode !== 200) return false;
                const uploadUrl = res.body.url;
                return request
                .put(uploadUrl)
                .set('Content-Type', contentType)
                .send(dataBlob)
                .then(res => {
                    if(res.statusCode !== 200)return false;
                    return request
                        .post(url + '/v1/room/file/upload_url/done')
                        .send({room: room, file_name: fileName})
                        .accept('application/json')
                        .set('Content-Type', 'application/json')
                        .set('Authorization', 'Bearer ' + token)
                        .then(res => {
                            if(res.statusCode !== 200 ) handleResponse(false)
                            else handleResponse(true)
                        })
                })
        })
    }

    mailConversation(room, email) {
        const url = this.url();
        const token = this.token();
        return request
            .post(`${url}/v1/ticket/email`)
            .send({
                room: room,
                user_email: email
            })
            .set('Authorization', 'Bearer ' + token)
    }


    __setManyTicketPayload(conversations, type){
        const socket = this.socket()
        const token = this.token()
        return (dispatch)=>{
            if(!conversations.room.length) return
            dispatch(this.setsType(conversations.room, type))
            dispatch(this.addBulkEntries(conversations.entries));
            dispatch(this.setsInfo(conversations.info))
            if(type !== 'intern'){
                dispatch(CustomerModel.puts(conversations.customer))
            }
            dispatch(this.setsRead(conversations.read))
            if(type === 'resolved') return;
            conversations.room.forEach(room =>{
                socket.emit('join_conversation', room, token, 'employee');
            })

        }
    }

    readUnassignedFromDB(){
        const selectorFunction = (state) => {
            return {
                'unassigned': this.selector.unassignedTickets(state),
                //'network': NetworkSelector.get(state, 'CONVERSATION_UNASSSIGNED_READ')
            }
        }
        const dispatchFunction = (room)=> {
            return (dispatch) => {
                var url = this.url()
                var token = this.token()
                return request
                    .post(`${url}/v1/ticket/unassigned/get`)
                    .accept('application/json')
                    .send({room: room})
                    .set('Authorization', 'Bearer ' + token)
                    .end((err, res) => {
                        if (res.statusCode === 200){
                            const conversations = res.body.conversations
                            dispatch(this.__setManyTicketPayload(conversations, 'unassigned'))
                        }
                    });
            }
        }
        return { selector: selectorFunction, dispatcher: dispatchFunction }
    }

    readAssignedFromDB(){
        const selectorFunction = (state) => {
            return {
                'assigned': this.selector.assignedTickets(state),
                //'network': NetworkSelector.get(state, 'CONVERSATION_UNASSSIGNED_READ')
            }
        }
        const dispatchFunction = (room)=> {
            return (dispatch) => {
                var url = this.url()
                var token = this.token()
                return request
                    .post(`${url}/v1/ticket/assigned/get`)
                    .accept('application/json')
                    .send({room: room})
                    .set('Authorization', 'Bearer ' + token)
                    .end((err, res) => {
                        if (res.statusCode === 200){
                            const conversations = res.body.conversations
                            dispatch(this.__setManyTicketPayload(conversations, 'assigned'))
                        }
                    });
            }
        }
        return { selector: selectorFunction, dispatcher: dispatchFunction }
    }

    readInternFromDB(){
        const selectorFunction =  {
            intern:(state)=>this.selector.internCoworkerConversations(state),
            network:(state)=>this.network.get(state, 'CONVERSATION_UNASSSIGNED_READ').toJS()
        }
        const dispatchFunction = (room)=> {
            return (dispatch) => {
                var url = this.url()
                var token = this.token()
                return request
                    .post(`${url}/v1/intern/get`)
                    .accept('application/json')
                    .send({room: room})
                    .set('Authorization', 'Bearer ' + token)
                    .end((err, res) => {
                        if (res.statusCode === 200){
                            const conversations= res.body.conversations
                            dispatch(this.__setManyTicketPayload(conversations, 'intern'))
                        }
                    });
            }
        }
        return { selector: selectorFunction, dispatcher: dispatchFunction }
    }

    getLatestAssignedTickets(...args) {
        return this.getLatestTicketsRequest(...args)
    }

    getLatestTicketsRequest(limit, offset=0) {
        const url = this.url()
        const token = this.token()
        return request
            .post(`${url}/v2/company/ticket/assigned/get/latest`)
            .accept('application/json')
            .send({ limit, offset })
            .set('Authorization', 'Bearer ' + token)
    }
}


export default new Conversation();



// WEBPACK FOOTER //
// ./src/model/Conversation/model.js